export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAIL = "RESET_PASSWORD_FAIL";
export const CUSTOMER_CREATE_SUCCESS = "CUSTOMER_CREATE_SUCCESS";
export const CUSTOMER_CREATE_FAIL = "CUSTOMER_CREATE_FAIL";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_FAIL = "SIGNUP_FAIL";
export const SEND_OTP_SUCCESS = "SEND_OTP_SUCCESS";
export const SEND_OTP_FAIL = "SEND_OTP_FAIL";
/* Roles */
export const ROLES_ALL = [
  "idealadmin",
  "idealsupport",
  "clientadmin",
  "clientmanager",
  "clientuser"
];
export const ROLES_IDEAL = ["idealadmin", "idealsupport"];
export const ROLES_IDEAL_ADMIN = ["idealadmin"];
export const ROLES_IDEAL_SUPPORT = ["idealsupport"];
export const ROLES_CLIENT = ["clientadmin", "clientmanager", "clientuser"];
export const ROLES_CLIENT_ADMIN = ["clientadmin"];
export const ROLES_CLIENT_MANAGER = ["clientmanager"];
export const ROLES_CLIENT_ADMIN_MANAGER = ["clientadmin", "clientmanager"];
export const ROLES_CLIENT_USER = ["clientuser"];

export const CUSTOM_METADATA_STANDARD = "custom";

export const HELP_PAGE_URL =
  "https://www.trend-networks.com/UK/EN/Support/english-product-manuals.aspx";
export const SUPPORT_PAGE_URL =
  "https://www.trend-networks.com/UK/EN/Support/index.aspx";

export const CUSTOM_TEST_STANDARD = "custom";
